export default "__VITE_ASSET__8c0fbfd0__"